import { HubConnectionState } from "@microsoft/signalr";

export const sendSignalRSafe = async (connection, callbackFunc) => {
    if (connection && connection.state === HubConnectionState.Connected) {
        await callbackFunc(connection)
    }
}
